import { Controller } from "stimulus"

// Infinite scroll for the AI Jobs feed. When the sentinel element
// enters the viewport, fetches the next page and appends job entries.
export default class extends Controller {
  static targets = ["feed", "sentinel", "count"]
  static values = { url: String, page: Number, loading: Boolean, exhausted: Boolean }

  connect() {
    this.pageValue = this.pageValue || 1
    this.loadingValue = false
    this.exhaustedValue = false

    const scrollEl = this.element.closest('.ai-jobs-right-scroll')
    const isScrollable = scrollEl && getComputedStyle(scrollEl).overflowY !== 'visible'

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loadingValue && !this.exhaustedValue) {
            this.loadMore()
          }
        })
      },
      { root: isScrollable ? scrollEl : null, rootMargin: "400px" }
    )

    if (this.hasSentinelTarget) {
      this.observer.observe(this.sentinelTarget)
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  async loadMore() {
    this.loadingValue = true
    this.pageValue += 1

    // Build the URL preserving any existing filter params
    const urlObj = new URL(this.urlValue, window.location.origin)
    urlObj.searchParams.set("page", this.pageValue)

    try {
      const response = await fetch(urlObj.pathname + urlObj.search, {
        headers: { "Accept": "text/html" }
      })

      if (!response.ok) {
        this.exhaustedValue = true
        this.hideSentinel()
        return
      }

      const html = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")
      const newItems = doc.querySelectorAll(".ai-job-item")

      if (newItems.length === 0) {
        this.exhaustedValue = true
        this.hideSentinel()
        return
      }

      newItems.forEach((item) => {
        this.feedTarget.appendChild(item)
      })

      // Fewer than a full page = last page
      if (newItems.length < 20) {
        this.exhaustedValue = true
        this.hideSentinel()
      }
    } catch (e) {
      this.exhaustedValue = true
      this.hideSentinel()
    } finally {
      this.loadingValue = false
    }
  }

  hideSentinel() {
    if (this.hasSentinelTarget) {
      this.sentinelTarget.style.display = "none"
    }
  }
}
